import { contractRequest } from "./transport";
import type {
  InvitePreview,
  MessageResponse,
  PhysicianAuthResponse,
  PhysicianProfile,
  PhysicianSignupRequest,
} from "./types";

// Public + physician-token endpoints from the MODULE 1 API CONTRACT. The refresh
// token itself never appears here — like the patient portal, it rides an httpOnly
// cookie the browser handles.

/** 200 { email, expiresAt } · 404 INVITE_INVALID · 410 INVITE_EXPIRED */
export const getPhysicianInviteApi = (token: string) =>
  contractRequest<InvitePreview>(`/api/physician/invitations/${encodeURIComponent(token)}`, { method: "GET" });

/** Unauthenticated, from the invite email's decline link · 404 INVITE_INVALID · 410 INVITE_EXPIRED */
export const declinePhysicianInviteApi = (token: string) =>
  contractRequest<MessageResponse>(`/api/physician/invitations/${encodeURIComponent(token)}/decline`, { method: "POST" });

/**
 * Accepts the invitation with a password and signs the physician in (same
 * response and refresh cookie as login) — no OTP step. The email comes from
 * the invitation server-side; it is deliberately not sent.
 */
export const physicianSignupApi = (body: PhysicianSignupRequest) =>
  contractRequest<PhysicianAuthResponse>("/api/physician/auth/signup", { method: "POST", body });

/** 401 INVALID_CREDENTIALS for wrong password, unknown email, or no PHYSICIAN role alike. */
export const physicianLoginApi = (email: string, password: string) =>
  contractRequest<PhysicianAuthResponse>("/api/physician/auth/login", { method: "POST", body: { email, password } });

export const physicianRefreshApi = () =>
  contractRequest<PhysicianAuthResponse>("/api/physician/auth/refresh", { method: "POST" });

export const physicianLogoutApi = () =>
  contractRequest<MessageResponse>("/api/physician/auth/logout", { method: "POST", portal: "physician" });

export const getPhysicianMeApi = () =>
  contractRequest<PhysicianProfile>("/api/physician/me", { method: "GET", portal: "physician" });
